// eslint-disable-next-line 
import util from 'util';

/*
 * Checks if an account has a feature enabled and returned boolean back.
 * If the feature does not exist, or the account is undefined, returns false.
 */
export function isFeatureEnabled(account, featureCode) {
    let isEnabled = false;
    if (account !== undefined && account !== null) {
      if (Object.hasOwn(account, 'accountFeatures')) {
        let feat = account.accountFeatures[featureCode];
        if (feat !== undefined && feat !== null) {
          if (Object.hasOwn(feat, 'status')) {
            if (feat.status === 'ENABLED') {
              isEnabled = true;
            }
          }
        }
      }
    }

    return isEnabled;
}